import React from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalBody } from 'components/qstrap'
import Title from './Title'
import Details from './Details'

class ModalWrapper extends React.Component {
  constructor() {
    super()
    this.state = {
      modal: false,
    }

    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    })
  }

  render() {
    return (
      <div id="aptitude-answering-instructions">
        <a onClick={this.toggle} className="instructions-toggler">
          <Title className="p-a-md" />
        </a>
        <Modal autoFocus={false} isOpen={this.state.modal} toggle={this.toggle} fade={false} id="aptitude-instruction-modal">
          <ModalBody>
            <Details factor={this.props.factor} />
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

ModalWrapper.propTypes = {
  factor: PropTypes.string.isRequired,
}

export default ModalWrapper
